module.exports = __webpack_public_path__ + "img/15.67aac8d8.png";